/**
 * Normalizes a session GET/open response. `totpSecret` is null for a STATIC-QR
 * event the scheduled window opened (it never needs one); `closesAt` is the
 * next scheduled auto-close, null when the session stays open until closed by hand.
 * @param {object} data
 * @returns {{ totpSecret: string | null, step: number, openedAt?: string, closesAt: string | null }}
 */
export function extractSession(data) {
  if (!data?.step) {
    throw new Error(
      `Check-in session response missing required fields. Got keys: ${Object.keys(data || {}).join(
        ', ',
      )}`,
    );
  }
  return {
    totpSecret: data.totpSecret ?? null,
    step: data.step,
    openedAt: data.openedAt,
    closesAt: data.closesAt ?? null,
  };
}
